import {APIURLLEGALES} from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter  {
  async fetchLiquidaciones(cuit,nroSiniestro,caratula,expediente,idJuicio) {
    const url=APIURLLEGALES + `/liquidacion/Listar?cuit=${cuit||''}&nroSiniestro=${nroSiniestro||''}&caratula=${caratula||''}&nroexpediente=${expediente||''}&idJuicio=${idJuicio||''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchObtenerComprobante(idLiquidacion,nroGestion,tieneFactura) {
    const url=APIURLLEGALES + `/liquidacion/ObtenerComprobante?idLiquidacion=${idLiquidacion||''}&nroGestion=${nroGestion||''}&tieneFactura=${tieneFactura||''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }
  async fetchObtenerRetenciones(idLiquidacion,nroGestion) {
    const url=APIURLLEGALES + `/liquidacion/ObtenerDetalleRetencion?nroGestion=${nroGestion||''}&idLiquidacion=${idLiquidacion||''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchFacturasLiquidaciones(idLiquidacion, cuitLetrado, idPrestador, idJuicio, fechaFacturaInicio, fechaFacturaFin, fechaAltaInicio, fechaAltaFin, nroFactura, idEstadoLiquidacionWeb, monImporteFacDesde, monImporteFacHasta, idAnalista, idTipoFactura, etapaFacturacion, cuitPrestador) {
    const url = APIURLLEGALES + `/liquidacion/ListarFacturas?idLiquidacionWeb=${idLiquidacion || ''}&FechaFacturaInicio=${encodeURIComponent(fechaFacturaInicio) || ''}&FechaFacturaFin=${encodeURIComponent(fechaFacturaFin) || ''}&FechaAltaInicio=${encodeURIComponent(fechaAltaInicio) || ''}&FechaAltaFin=${encodeURIComponent(fechaAltaFin) || ''}&nroFactura=${encodeURIComponent(nroFactura)}&cuitLetrado=${cuitLetrado || ''}&idPrestador=${idPrestador || ''}&monImporteFacDesde=${monImporteFacDesde || ''}&monImporteFacHasta=${monImporteFacHasta || ''}&idJuicio=${idJuicio || ''}&idEstadoLiquidacionWeb=${idEstadoLiquidacionWeb || ''}&idAnalista=${idAnalista || ''}&idTipoFactura=${idTipoFactura || ''}&etapaFacturacion=${etapaFacturacion || ''}&cuitPrestador=${cuitPrestador || ''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async validarFactura(nroFactura, cuit) {
    const url=APIURLLEGALES + `/liquidacion/ValidarFactura?nroFactura=${nroFactura||''}&cuit=${cuit||''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async guardarFactura(body) {
    const url=APIURLLEGALES + `/liquidacion/EnviarFactura`
    const response = apiClient.postData(url,body)
    const data = await response
    return data;
  }

  async fetchPagosSinFactura(idLiquidacion, cuitLetrado, idJuicio, fechaVtoInicio, fechaVtoFin, fechaAltaInicio, fechaAltaFin, monImporteFacDesde, monImporteFacHasta) {
    const url = APIURLLEGALES + `/pagossinfactura/listar?idLiquidacionWeb=${idLiquidacion || ''}&fechaVtoInicio=${encodeURIComponent(fechaVtoInicio) || ''}&fechaVtoFin=${encodeURIComponent(fechaVtoFin) || ''}&FechaAltaInicio=${encodeURIComponent(fechaAltaInicio) || ''}&FechaAltaFin=${encodeURIComponent(fechaAltaFin) || ''}&cuitLetrado=${cuitLetrado || ''}&monImporteFacDesde=${monImporteFacDesde || ''}&monImporteFacHasta=${monImporteFacHasta || ''}&idJuicio=${idJuicio || ''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchAltaPago(body) {
    const url=APIURLLEGALES + `/pagossinfactura/enviar`
    const response = apiClient.post(url, body)
    const data = await response
    return data;
  }

  
  async fetchDetallePagosSinFactura(idLiquidacion ) {
    const url = APIURLLEGALES + `/pagossinfactura/ObtenerDetalle?intIdLiquidacionWebSinFacturaPago=${idLiquidacion || ''}`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchFormaPago( ) {
    const url = APIURLLEGALES + `/pagossinfactura/ListarFormasPago`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }

  async fetchDetalleFormaPago( ) {
    const url = APIURLLEGALES + `/pagossinfactura/ListarDetalleFormasPago`
    const response = apiClient.get(url)
    const data = await response
    return data;
  }
}

export default ApiServiceAdapter